<template>
    <div class="entry-content view-courses">
        <v-client-table
			v-if="!preloaderVisibility"
			v-model="courseTemplates"
			:columns="columnsOptions"
			:options="options"
		>
            <div slot="h__name">Title</div>
            <router-link
                class="select-button"
                slot="select"
                slot-scope="courses"
                :to="`/course-assign/${courses.row.courseTemplateId}/lessons`"
            >Select</router-link>
        </v-client-table>
        <div
            v-if="preloaderVisibility"
            class="table-skeleton"
        />
		<PreloaderComponent v-if="preloaderVisibility"/>
		<Paginate
			v-if="pageCount !== 1 && courseTemplates.length"
			v-model="currentPage"
			:page-count="pageCount"
			:container-class="'pagination'"
			:page-class="'page-item'"
			:prev-text="'<'"
			:next-text="'>'"
			:prev-class="'page-item'"
			:next-class="'page-item'"
			:click-handler="paginationHandler"/>
    </div>
</template>
 
<script>
import Paginate from 'vuejs-paginate'

import CheckAPI from '@/api'
import PreloaderComponent from '@/components/common/PreloaderComponent'

export const tableOptions = {
	resizableColumns: false,
	perPage: 30,
	perPageValues: [],
	filterable: [],
	highlightMatches: false,
	filterByColumn: false,
	sortable: [],
	skin: '',
	hiddenColumns: ['id'],
	headings: {
		delete: false,
		edit: false,
        select: false
	}
};

export default {
 name: "CourseTemplatePage",
    components: {
        PreloaderComponent,
        Paginate,
    },
    data() {
		return {
            columnsOptions: ['name', 'select'],
            courseTemplates: [],
            options: tableOptions,
            pageCount: 0,
            total: 0,
            currentPage: 1,
            size: 30,
            preloaderVisibility: true
        }
    },
    mounted() {
        this.setInitialPage();
    },
    methods: {
        async fetchCourseTemplates() {
			this.currentPage = parseInt(this.$route.query.page)
            const response = await CheckAPI.getAssignableCourses(
				this.currentPage - 1,
				this.size
			);
            this.total = response.data.data.total_items
			this.pageCount = response.data.data.total_pages
			const courses = response.data.data.items.map(singleStudent => ({
				...singleStudent,
				fullName: singleStudent.studentFirstName + ' ' + singleStudent.studentLastName
			}))
            this.courseTemplates = courses
            this.preloaderVisibility = false
        },
        setPage() {
			this.currentPage = parseInt(this.$route.query.page || 1);
			this.$router.push({path: this.$route.path, query: { page: parseInt(this.$route.query.page || 1) }})
			this.fetchCourseTemplates();
		},
		setInitialPage() {
			if (this.$route.query.page !== 1) {
				this.currentPage = parseInt(this.$route.query.page || 1);
				this.$router.push({path: this.$route.path, query: { page: parseInt(this.$route.query.page || 1) }})
				this.fetchCourseTemplates();
			}
		},
		paginationHandler(e) {
			this.currentPage = e;
			this.$router.push({path: parseInt(this.$route.path), query: { page: parseInt(e) }})
			this.preloaderVisibility = true
		},
		async onDeleteCourse(id) {
			await CheckAPI.handleCourseDelete(id)
			this.fetchCourseTemplates()
		}
    },
    watch: {
		'$route.query.page': {
			deep: true,
			handler() {
				this.preloaderVisibility = true;
				this.setPage();
			}
		}
	}
}
</script>

<style lang="scss" scoped>
    .select-button {
        color: #141638;
        border: 0.0625em solid #141638;
        background-color: transparent;
        border-radius: 25px;
        padding: 4px 25px;
        cursor: pointer;
    }
</style>
